import { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { VersionContext } from "../context";
import { getPlatform } from "../utils";

const Home = () => {
  const { apiIsDone, appVersionData } = useContext(VersionContext);
  const navigate = useNavigate();
  const platform = getPlatform();

  useEffect(() => {
    if (apiIsDone) {
      if (platform === "Android" && appVersionData.androidVersionInfo) {
        navigate("/transfer", { replace: true });
      } else if (platform === "iOS" && appVersionData.iosVersionInfo) {
        navigate("/ios", { replace: true });
      } else if (
        !appVersionData.androidVersionInfo ||
        !appVersionData.iosVersionInfo
      ) {
        navigate("/error", { replace: true });
      }
    }
  }, [appVersionData]);

  return (
    <div className="homePgae">
      <div className="fullContainer"></div>
    </div>
  );
};

export default Home;
